Weglot.on("switchersReady", function(initialLanguage) {
  console.log("rdy");
  initLangs();
})


function wait4element(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


var initLangsMobile = (function() {
  var executed = false;

  return function() {
        if (!executed) {
            executed = true;

            if (!Weglot) {
                return;
            }


          
            var availableLanguages = Weglot.options.languages
                .map(function(language) {
                    return language.language_to;
                })
                .concat(Weglot.options.language_from);
            
          
              var currentLang = Weglot.getCurrentLang();
              var currentLangName = Weglot.getLanguageName(currentLang);
              //console.log(currentLang);
              
              var switcher_container_mobile = document.getElementById("mobile_switcher");

            //Create and append the options
              for (var i = 0; i < availableLanguages.length; i++) {
                  var lang = availableLanguages[i];
                  var list = document.createElement("li");
                  if(lang==currentLang){
                    list.innerHTML = "<a class='switcher_link switcher_link-"+lang+" selected' data-lang='"+lang+"' href='#'>" + Weglot.getLanguageName(lang); + "</a>";
                  } else {
                    list.innerHTML = "<a class='switcher_link switcher_link-"+lang+"' data-lang='"+lang+"' href='#'>" + Weglot.getLanguageName(lang); + "</a>";
                  }
                  switcher_container_mobile.insertBefore(list, switcher_container_mobile.children[0]);
          
              }

            var mobile_current_lang_link = document.getElementById("mobile_current_lang");
            mobile_current_lang_link.innerHTML = "<span class='current-lang current-lang-"+currentLang+"'>"+currentLangName+"</span>";


      
        
            $(".switcher_link").click(function() {
              Weglot.switchTo($(this).attr("data-lang"));
              console.log("cliked wisthto")
            });
            
            Weglot.on("languageChanged", function(lang) {
               // selectList.value = lang;
            });




          
        }
    };
})();
  
  /*function initLangsMobile() {
   
  
    if (!Weglot) {
        return;
    }
    var availableLanguages = Weglot.options.languages
        .map(function(language) {
            return language.language_to;
        })
        .concat(Weglot.options.language_from);
         
    var currentLang = Weglot.getCurrentLang();
    var currentLangName = Weglot.getLanguageName(currentLang);
    console.log(currentLang);
    var switcher_container_mobile = document.getElementById("mobile_switcher");
    var mobile_current_lang_link = document.getElementById("mobile_current_lang");
    mobile_current_lang_link.innerHTML = ""+currentLangName;

  
    if (switcher_container_mobile.childNodes.length < 1) {
    //Create and append the options
      for (var i = 0; i < availableLanguages.length; i++) {
          var lang = availableLanguages[i];
          var list = document.createElement("li");
          if(lang==currentLang){
            list.innerHTML = "<a class='switcher_link selected' data-lang='"+lang+"' href='#'>" + Weglot.getLanguageName(lang); + "</a>";
          } else {
            list.innerHTML = "<a class='switcher_link' data-lang='"+lang+"' href='#'>" + Weglot.getLanguageName(lang); + "</a>";
          }
          switcher_container_mobile.insertBefore(list, switcher_container_mobile.children[0]);
  
      }
    }

    $(".switcher_link").click(function() {
      Weglot.switchTo($(this).attr("data-lang"));
      console.log("cliked wisthto")
    });
    
    Weglot.on("languageChanged", function(lang) {
       // selectList.value = lang;
    });
}
*/
function initLangs() {
    var currency_lang_list = document.getElementById("currency_lang");
    
    if (!Weglot) {
        return;
    }
    var availableLanguages = Weglot.options.languages
        .map(function(language) {
            return language.language_to;
        })
        .concat(Weglot.options.language_from);
         
    var currentLang = Weglot.getCurrentLang();
    var currentLangName = Weglot.getLanguageName(currentLang);
    console.log(currentLang);
    var switcher_container = document.getElementById("switcher_span");
    switcher_container.innerHTML = "<span class='current-lang current-lang-"+currentLang+"'>"+currentLangName+"</span>";

  
    //Create and append the options
    for (var i = 0; i < availableLanguages.length; i++) {
        var lang = availableLanguages[i];
        var option = document.createElement("li");
      
        option.innerHTML = "<a class='switcher_link switcher_link-"+lang+"'  data-lang='"+lang+"' href='#'>" + Weglot.getLanguageName(lang); + "</a>"
        currency_lang_list.insertBefore(option, currency_lang_list.children[0]);

        if (lang === currentLang) {
                   
        }
    }

    $(".switcher_link").click(function() {
      Weglot.switchTo($(this).attr("data-lang"));
    });
    
    Weglot.on("languageChanged", function(lang) {
       // selectList.value = lang;
    });
}


// initLangs();